import { GraphQLErrors } from '@apollo/client/errors';
import { Box, Typography } from '@mui/material';

const GraphQLErrors = ({ graphQLErrors }: { graphQLErrors: GraphQLErrors | undefined }) => {
  return (
    <>
      {graphQLErrors && (
        <Box mb={1}>
          <Typography color="error">
            {`Error: `}
            {graphQLErrors.map((n) => n.message)}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default GraphQLErrors;